// import CryptoJS from 'crypto-js';

// const Encryption_Key ='YmveUG7q4KK+R/8izaUwVw=='  // RBAC121!@#1151



// export const setLoginEncryptedLocalStorage = (data) =>{
// try {
    
//     const encryptedToken = CryptoJS.AES.encrypt(JSON.stringify(data.token), Encryption_Key).toString();
//     localStorage.setItem(`token-rbac`, encryptedToken);
// } catch (error) {
//     console.error('Error setting encrypted local storage:', error);   
// }
// }

// export const removeLoginEncryptedLocalStorage = () => {
//     try {
//       localStorage.removeItem('token-rbac');
//       localStorage.removeItem("data");
//     } catch (error) {
//       console.error('Error setting encrypted local storage:', error);
//     }
//   };
  

  
//   // Function to remove an encrypted item from local storage
//   export const checkEncryptedLocalStorageItem = () => {
//     try {
//       return localStorage.getItem('token-rbac') !== null;
//     } catch (error) {
//       console.error('Error removing encrypted local storage:', error);
//       return false;
//     }
//   };

//   export const setEncryptedLocalStorageItem = (key, value) => {
//     try {
//       const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), Encryption_Key).toString();
//       localStorage.setItem(`RBAC-${key}`, encryptedValue);
//     } catch (error) {
//       console.error('Error setting encrypted local storage:', error);
//     }
//   };

//   export const getEncryptedLocalStorageItem = (key) => {
//     try {
//       const encryptedValue = localStorage.getItem(`${key}`);
//       if (encryptedValue) {
//         const bytes = CryptoJS.AES.decrypt(encryptedValue, Encryption_Key);
//         const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
  
//         // Check if the decrypted value is a valid JSON string
//         if (decryptedValue) {
//           return JSON.parse(decryptedValue);
//         } else {
//           console.error('Decrypted value is not a valid JSON string');
//           return null;
//         }
//       }
//       return null;
//     } catch (error) {
//       console.error('Error getting encrypted local storage:', error);
//       return null;
//     }
//   };
import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = '4bcbe98c05f58cb9d7cb0e14715d8dc382e405f0bb5f74463aae0fd0e547ce8b'; //AguaEnterprise!@#11551

export const setEncryptedLocalStorageItem = (key, value) => {
    try {
      const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), ENCRYPTION_KEY).toString();
      localStorage.setItem(`RBAC-${key}`, encryptedValue);
    } catch (error) {
      console.error('Error setting encrypted local storage:', error);
    }
  };

  // Function to get an encrypted item from local storage
// Function to get an encrypted item from local storage
export const getEncryptedLocalStorageItem = (key) => {
    try {
      const encryptedValue = localStorage.getItem(`RBAC-${key}`);
      if (encryptedValue) {
        const bytes = CryptoJS.AES.decrypt(encryptedValue, ENCRYPTION_KEY);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);

        // Check if decryptedValue is not null or empty before parsing
        if (decryptedValue) {
          return JSON.parse(decryptedValue);
        }
      }
      return null;
    } catch (error) {
      console.error('Error getting encrypted local storage:', error);
      return null;
    }
};


export const removeLoginEncryptedLocalStorage = () => {
  try {
    localStorage.removeItem('token-rbac');
    localStorage.removeItem("rbac-data");
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to remove an encrypted item from local storage
export const checkEncryptedLocalStorageItem = () => {
  try {
    return   localStorage.removeItem('token-rbac') !== null;
  } catch (error) {
    console.error('Error removing encrypted local storage:', error);
    return false;
  }
};